<template>
  <button
    class="flex items-center justify-center h-8 w-8 bg-grey-100 rounded-full cursor-pointer"
    @click="handleClick" tabindex="-1"
  >
    <SvgLocationPin class="text-grey-400 h-4 w-4" />
  </button>
</template>

<script>
import getCurrentCoordinates from '@/utils/getCurrentCoordinates'
import SvgLocationPin from '@/components/svg/LocationPin'

export default {
  components: { SvgLocationPin },
  methods: {
    async handleClick () {
      const { latitude, longitude } = await getCurrentCoordinates()
      // const test = await getPlacesNearby({ lat: latitude, lng: longitude })
      // @TODO: Prefill departure airport using these coordinates. Maybe make this a component?
      this.$emit('change')
    },
  }
}
</script>

<style scoped>

</style>
